import normalizeComponent from '../../node_modules/vue-runtime-helpers/dist/normalize-component.mjs.js';
import script from './AvatarNameLoader.vue_rollup-plugin-vue=script.js';

/* script */
const __vue_script__ = script;

/* template */
var __vue_render__ = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    "ContentLoader",
    {
      attrs: {
        "view-box": "0 0 150 24",
        height: "24px",
        "preserve-aspect-ratio": "xMinYMid meet",
        width: "150px"
      }
    },
    [
      _c("circle", { attrs: { cx: "12", cy: "12", r: 12 } }),
      _vm._v(" "),
      _c("rect", {
        attrs: { x: "28", y: "4", rx: 8, ry: 8, width: 45, height: 16 }
      }),
      _vm._v(" "),
      _c("rect", {
        attrs: { x: "78", y: "4", rx: 8, ry: 8, width: 70, height: 16 }
      })
    ]
  )
};
var __vue_staticRenderFns__ = [];
__vue_render__._withStripped = true;

  /* style */
  const __vue_inject_styles__ = undefined;
  /* scoped */
  const __vue_scope_id__ = undefined;
  /* module identifier */
  const __vue_module_identifier__ = undefined;
  /* functional template */
  const __vue_is_functional_template__ = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  );

export default __vue_component__;



// WEBPACK FOOTER //
// ./node_modules/@spartez/vue-atlaskit/dist/components/ContentLoader/AvatarNameLoader.vue.js